import { parseJSONifiedStringOrGetRaw } from "./parseJSONifiedStringOrGetRaw";

export const getAgentFirmIdHeader = () => {
  const agentFirmId = localStorage.getItem("agent_firm_id");

  return (
    agentFirmId && {
      "X-agent-firm-id": parseJSONifiedStringOrGetRaw(agentFirmId),
    }
  );
};
